import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const SectionOne = () => {

  const words = [
  "Elite Developer",
  "Top-Tier Engineer",
  "Code Master",
  "Tech Visionary",
  "System Architect",
  "Innovation Leader"
];
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [reverse, setReverse] = useState(false);

  useEffect(() => {
    if (subIndex === words[index].length + 1 && !reverse) {
      setTimeout(() => setReverse(true), 800);
      return;
    }

    if (subIndex === 0 && reverse) {
      setReverse(false);
      setIndex((prev) => (prev + 1) % words.length);
      return;
    }

    const timeout = setTimeout(() => {
      setSubIndex(prev => prev + (reverse ? -1 : 1));
    }, reverse ? 70 : 120);

    return () => clearTimeout(timeout);
  }, [subIndex, index, reverse, words]);

  return (
    <>
      <div className='container-fluid every_page_mg_top'>
        <div className='row home_gradient_color'>
          <div className="col-md-1"></div>
          <div className='col-md-5'>

            <strong style={{ fontSize: '23px' }}>
              Learn smart. Code smarter.<br />

              <span style={{ color: "#358597ff" }}>
                Join the Top 1%.&nbsp;
              </span>

             <br/><br/>
              <span style={{ fontWeight: 'bold', color: '#364bc5' }}>
                {words[index].substring(0, subIndex)}
              </span>
              <span style={{ animation: 'blink 0.6s infinite' }}>|</span>
            </strong>
<br/><br/>
            <Link className='Link_text1' to='/Course'><button type="button" class="Subheader_btn_type_two" style={{marginLeft:'0'}}>ULTIMATE PLACEMENT SOLUTION <i className='fa fa-angle-right'></i> </button></Link>
          </div>

          <div className='col-md-6'>
            <img src="./images/Lucky.png" alt="img not available" className='homevideo' />
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes blink {
            50% { opacity: 0; }
          }
        `}
      </style>
    </>
  );
};

export default SectionOne;